var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMatchEnds(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M42.84,20.61a29,29,0,0,1-4.43,6.05A28.43,28.43,0,0,1,35,29.74v17.8H15.05V29.74a28.43,28.43,0,0,1-3.46-3.08,29,29,0,0,1-4.43-6.05l6.12-1.5,3.43,2,.19.11a4.22,4.22,0,0,1,2.47-.78H30.63a4.22,4.22,0,0,1,2.47.78l.18-.11,3.43-2Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.28,28.92h4.91a0,0,0,0,1,0,0V32.7a2.45,2.45,0,0,1-2.45,2.45h0a2.45,2.45,0,0,1-2.45-2.45V28.92A0,0,0,0,1,26.28,28.92Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 25,
    cy: 11.03,
    r: 6.66,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.42,5.62a3.2,3.2,0,0,1-.09.75L42.84,20.61l-6.13-1.5L40.2,4.87a3.15,3.15,0,0,1,6.22.75Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.28,19.11l-6.12,1.5L3.67,6.37a3.2,3.2,0,0,1-.09-.75,3.15,3.15,0,0,1,6.21-.75Z",
    style: {
      fill: "none",
      stroke: "#000",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.4,
    y1: 28.92,
    x2: 23.42,
    y2: 28.92,
    style: {
      fill: "none",
      stroke: "#000",
      strokeMiterlimit: 10,
      strokeWidth: 2
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatchEnds);
export default __webpack_public_path__ + "static/media/MATCH_ENDS.47bcaa46b6cb079b7630593439f694a1.svg";
export { ForwardRef as ReactComponent };